'use strict';

module.exports = /*@ngInject*/ ["$cookies", "ConfigService", function ($cookies, ConfigService) {
    var service = this;
    service.saveToken = function(token) {
        $cookies.put('nomad.noc.ng.token', token, { 
            secure: ConfigService.get('secureCookies')
        });
    };

    service.getToken = function() {
        // return localStorage.getItem("nomad.noc.ng.token");
        return $cookies.get('nomad.noc.ng.token');
    };

    service.deleteToken = function() {
        // return localStorage.getItem("nomad.noc.ng.token");
        $cookies.remove('nomad.noc.ng.token');
    };
}];